import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import ExerciseInputTable from 'pages/creator/exercises/exercise_input_table';

@observer
class ExerciseMultipleChoice extends React.Component {

  render() {
    return (
      <div className='exercise-multiple-choice'>
        <ExerciseInputTable
          hideBreakdown
          showMediaOptions
          showMultipleChoiceOptions
          {...this.props}
          hideInstruction
        />
      </div>
    );
  }
}

export default ErrorBoundary(ExerciseMultipleChoice);
